import { BRAND_GLOBAL_VARIABLE } from '../constants/brand-global'
import { BrandSettingsInterface } from '../types/brand-settings'

const hasOwn = (value: unknown, key: string): boolean =>
  value !== null && value !== undefined && Object.prototype.hasOwnProperty.call(value, key) === true

const isBrandSettings = (value: unknown): value is BrandSettingsInterface =>
  hasOwn(value, 'name') &&
  hasOwn(value, 'dashboardHostname') &&
  hasOwn(value, 'colors') &&
  hasOwn(value, 'logo') &&
  hasOwn(value, 'favicon')

export const setGlobalBrand = (brand: BrandSettingsInterface): void => {
  if (globalThis.window === undefined) {
    return
  }

  Object.defineProperty(globalThis, BRAND_GLOBAL_VARIABLE, {
    value: brand,
    writable: true,
    configurable: true,
  })
}

export const getGlobalBrand = (): BrandSettingsInterface | null => {
  if (globalThis.window === undefined) {
    return null
  }

  const brand = Object.getOwnPropertyDescriptor(globalThis, BRAND_GLOBAL_VARIABLE)?.value
  return isBrandSettings(brand) ? brand : null
}
